import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { lcmInterceptors } from './interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),

    provideHttpClient(withInterceptors(lcmInterceptors())),
    importProvidersFrom(MatMomentDateModule),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      // autoFocus prevents aria-warning in dev console; restore focus set
      // focus back to dialog handle after closing the dialog, simplifying
      // keyboard navigation
      useValue: { width: '50vw', autoFocus: 'dialog', restoreFocus: true },
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD/MM/yyyy',
        },
        display: {
          dateInput: 'DD/MM/yyyy',
          monthYearLabel: 'MMM yyyy',
          dateA11yLabel: 'DD',
          monthYearA11yLabel: 'MMMM yyyy',
        },
      },
    },
  ],
};
